/**
 * @file: isFaultLikeServiceSubject.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import {
  FaultServiceSubject,
  OtherServiceSubject,
  ServiceSubject,
} from '@euler/model';
import { ServiceSubjectType } from '@euler/model/enum';

export const isFaultLikeServiceSubject = (
  subject: ServiceSubject,
): subject is FaultServiceSubject | OtherServiceSubject => {
  return (
    subject.type === ServiceSubjectType.Fault ||
    subject.type === ServiceSubjectType.Other
  );
};
